import { ToothFullHeadMPRSliceGeometry } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import { GEOMETRY_SOURCE_TO_PROTO, type ToothGeometrySource } from '../config';

export const makeFullHeadMprSliceGeometry = ({
  geometrySource,
  heightPx,
  scaleMmPerPx,
  thicknessMm,
  volumeFileID,
  widthPx,
}: {
  geometrySource: ToothGeometrySource | 'view';
  heightPx: number;
  scaleMmPerPx: number;
  thicknessMm: number;
  volumeFileID: string;
  widthPx: number;
}): ToothFullHeadMPRSliceGeometry =>
  new ToothFullHeadMPRSliceGeometry({
    GeometrySource: GEOMETRY_SOURCE_TO_PROTO[geometrySource],
    HeightPx: Math.round(heightPx),
    Scale: scaleMmPerPx,
    ThicknessMm: thicknessMm,
    VolumeFileID: volumeFileID,
    WidthPx: Math.round(widthPx),
  });
